export default "__VITE_ASSET__b28155dd__"